import { render, staticRenderFns } from "./AddMaterialModal.vue?vue&type=template&id=5b5c78fa&scoped=true"
import script from "./AddMaterialModal.vue?vue&type=script&lang=js"
export * from "./AddMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./AddMaterialModal.vue?vue&type=style&index=0&id=5b5c78fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c78fa",
  null
  
)

export default component.exports